import { differenceInYears } from "date-fns";
import * as yup from "yup";
import "yup-phone-lite";
import { AURA_VALIDATION_MESSAGES } from "../config/const/enums";
import {
  CONTACT_NUMBER_NOT_VALID,
  CONTACT_NUMBER_STARTING_WITH,
  DOB_MAX_AGE,
  DOB_MIN_AGE,
  INVALID_DATE,
  MAX_NUMBER_CHARACTERS,
  SURNAME_LENGTH,
  SURNAME_NOT_VALID,
  SURNAME_REGEX,
} from "./preQualValidationSchema";
import { LIFE_COVER_MAX_AGE, LIFE_COVER_MIN_AGE } from "./sharedConstValues";

export const ccRetrieveSchema = yup.object().shape({
  quoteNumber: yup
    .string()
    .test(
      "is-alphanumeric",
      "Only alphanumeric characters are allowed",
      (value) => {
        if (!value) return true;
        return /^[a-zA-Z0-9]*$/.test(value);
      }
    ),
  phoneNumber: yup
    .string()
    .phone("AU", CONTACT_NUMBER_NOT_VALID)
    .test("is-mobileValid", CONTACT_NUMBER_STARTING_WITH, (value) => {
      if (!value) return true;
      return /^(04\d{8})?$/.test(value);
    }),
  surname: yup
    .string()
    .max(MAX_NUMBER_CHARACTERS, SURNAME_LENGTH)
    .test("is-surnameValid", SURNAME_NOT_VALID, (value) => {
      if (!value) return true;
      return SURNAME_REGEX.test(value);
    }),
  dateOfBirth: yup
    .date()
    .nullable()
    .typeError(INVALID_DATE)
    .test("dob_max", DOB_MAX_AGE, function (value) {
      return value
        ? differenceInYears(new Date(), new Date(value)) <= LIFE_COVER_MAX_AGE
        : true;
    })
    .test("dob_min", DOB_MIN_AGE, function (value) {
      return value
        ? differenceInYears(new Date(), new Date(value)) >= LIFE_COVER_MIN_AGE
        : true;
    }),
});

export const ccProcessingSchema = yup.object().shape({
  ccAccountName: yup.string().required(AURA_VALIDATION_MESSAGES.FIELD_REQUIRED),
  ccAction: yup.string().required(AURA_VALIDATION_MESSAGES.FIELD_REQUIRED),
});

export const retrieveSelectedRow = yup.object().shape({
  selectedRow: yup.string().required("Please select at least one row"),
});

export const onlineRetrieveQuoteSchema = yup.object().shape({
  quoteNumber: yup
    .string()
    .test(
      "is-alphanumeric",
      "Only alphanumeric characters are allowed",
      (value) => {
        if (!value) return true;
        return /^[a-zA-Z0-9]*$/.test(value);
      }
    )
    .required(AURA_VALIDATION_MESSAGES.FIELD_REQUIRED),
});
